import {createAction} from "@reduxjs/toolkit";

export const resetAll = createAction("reset");